<div class="main-container" [class.no-sidebar]="!isLoggedIn">
  <app-global-header *ngIf="deviceSize === 'mobile' && showHeader()" [showBack]="showBack()" [showPremium]="showPremium()" [showActions]="showActions()" [user]="user"></app-global-header>
  <div class="router-outlet-container">
    <app-sidebar *ngIf="sidebarEnabled"></app-sidebar>
    <router-outlet></router-outlet>
    <app-premium-feature-dialog></app-premium-feature-dialog>
  </div>
  <!--<app-global-footer *ngIf="deviceSize === 'mobile' && showFooter()"></app-global-footer>-->
</div>